import { useTypedParams } from '@sorare/routing';

import { MyClubSlugLayout as MyClubSlugLayoutComponent } from 'layouts/MyClubSlugLayout';

import type { LayoutParams } from './__generated__/routeParams';

export { loader } from 'layouts/MyClubSlugLayout';

const MyClubSlugLayout = () => {
  const { type } = useTypedParams<LayoutParams>();
  return <MyClubSlugLayoutComponent type={type} />;
};

export default MyClubSlugLayout;
